"use strict";

angular.module('app.controllers.devices', ['app.controllers.devices.dataPoint'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('devices', {
        parent: 'site',
        url: '/devices/:deviceTypeFilter/:menuEntryFilter/:filterButton',
        template: '<ui-view></ui-view>',
        params: {
            filterButton: 'true',
            deviceTypeFilter: 'false',
            menuEntryFilter: 'false',
            favorite : null
        },
        infoGuide : {
            state: 'deviceManagement'
        },
        breadcrumb: {
            initialState: true,
            name: 'NAV_Devices'
        },
        resolve: {
            DeviceFilter: function ($stateParams) {
                'ngInject';

                var f = {
                    WithDetails: true,
                    WithChildDevices: true,
                    Recursive: true
                };

                if ($stateParams.deviceTypeFilter !== 'false' && $stateParams.deviceTypeFilter !== "") {
                    f.DeviceTypes = $stateParams.deviceTypeFilter.split(',').map(Number);
                } else {
                    f.DeviceTypes = [];
                }
                if ($stateParams.menuEntryFilter !== 'false' && $stateParams.menuEntryFilter !== "") {
                    f.MenuEntries = $stateParams.menuEntryFilter.split(',');
                } else {
                    f.MenuEntries = [];
                }
                return f;
            },
            FilteredDevices: function (__Device, DeviceFilter, API, $filter, $rootScope,f_Devices) {
                'ngInject';

                $rootScope.$emit('loading-start');
                var _API = new API();
                return _API
                    .Device
                    .GetDevicesByFilter(DeviceFilter)
                    .$promise
                    .then(function (data) {
                        if (data) {
                            for (var i = 0; i < data.length; i++) {

                                data[i] = __Device.$buildRaw( data[i] ).$dispatch('build-view-datapoints');
                                f_Devices.addOrUpdateDevice(data[i]);
                            }
                            return $filter('orderBy')(data, ['+DeviceType', '+Name']);
                        }
                    }
                );
            },
            TopDevices: function (FilteredDevices) {
                'ngInject';

                const devices = [];
                for (let i = 0; i < FilteredDevices.length; i++) {
                    const dev = FilteredDevices[i];
                    if (!dev.ParendDeviceId ||
                        (dev.ParendDeviceId === "00000000-0000-0000-0000-000000000000" ? dev : false)) {
                            devices.push(dev);
                    }
                }
                return devices;

                // return _.each(FilteredDevices, function (i) {
                //     return !i.ParendDeviceId ||
                //         (i.ParendDeviceId === "00000000-0000-0000-0000-000000000000" ? i : false);
                // });

            },
            DevicesWithCustomFilter: function ($stateParams) {
                'ngInject';

                return $stateParams.filterButton;
            },
            IsFilterActivated: function ($stateParams) {
                'ngInject';

                return ($stateParams.deviceTypeFilter !== 'false' && $stateParams.deviceTypeFilter !== "") || ($stateParams.menuEntryFilter !== 'false' && $stateParams.menuEntryFilter !== "")
            }

        }
    });
}]).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('devices.view', {
        parent: 'devices',
        url: '/view',
        templateUrl: 'views/device_control.html',
        controller: 'DevicesCtrl',
        params: {
            passDevices: null
        },
        infoGuide : {
            state: 'deviceManagement'
        },
        breadcrumb: {
            initialState: true,
            name: 'NAV_Devices'
        }

    });
}]).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('devices.edit', {
        parent: 'devices',
        url: '/edit',
        templateUrl: 'views/device_control.edit.html',
        controller: 'DevicesEditCtrl',
        params: {
            passDevices: null
        },
        infoGuide : {
            state: 'deviceManagement'
        },
        breadcrumb: {
            initialState: true,
            name: 'NAV_Devices'
        },
        /*resolve: {
            TopDevices: function (Devices, __Device) {
                return Devices;
                var v = __Device.$collection();
                return v.$orderBy(['DeviceType', 'Name']).$asPromise();
            }
        }*/

    });
}]).//end config

controller("DevicesEditCtrl", ['$q', '$rootScope', '$scope', 'viewMenuBarService', '$state', 'infoModal', 'TopDevices', 'ENUM', '$translate', 'API',
    function ($q, $rootScope, $scope, viewMenuBarService, $state, infoModal, TopDevices, ENUM, $translate, API) {
        $scope.Devices = angular.copy(TopDevices);
        $scope.DeviceTypes = ENUM.getDeviceTypesByFilter(1);
        $scope.DeviceTypesAsKeys = ENUM.getDeviceTypesByFilter('1AsKey');
        $scope.isNewDeviceType = function (a, b) {
            if (b == undefined) return true;
            if (a == undefined) return true;
            return !(a == b);
        };

        const removeAngularProperties = (obj) => {
            const deviceToUpdate = {};
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const element = obj[key];
                    if (!key.startsWith('$')) {
                        deviceToUpdate[key] = element;
                    }
                }
            }
            return deviceToUpdate;
        }

        viewMenuBarService.changeButtons({
            'editButton': false,
            'startLearnButton': false,
            'revertButton': function () {
                $state.go('devices.view', {}, {reload: 'devices'});
            },
            'saveButton': function () {
                var devicesToChange = [];
                $scope.$emit('loading-start');

                const api = new API();
                
                for (var i = 0; i < $scope.Devices.length; ++i) {
                    //update changed devices
                    if ($scope.Devices[i].$UI && $scope.Devices[i].$UI.isChanged && !$scope.Devices[i].$UI.delete) {
                        // device to be updated
                        var updateDevice = angular.copy($scope.Devices[i]);
                        // delete not changed parameters
                        for (var key in updateDevice) {
                            if (key.localeCompare("DeviceId") !== 0 && key.charAt(0) !== '$' && updateDevice.$UI.changed && updateDevice.$UI.changed.indexOf(key) === -1) {
                                delete updateDevice[key];
                            }
                        }
                        // save changed device
                        devicesToChange.push(api.Device.UpdateDevice({ Device: removeAngularProperties(updateDevice) }).$promise);
                    }

                    // delete devices
                    if ($scope.Devices[i].$UI && $scope.Devices[i].$UI.delete) {
                        // device to delete
                        var deleteDevice = angular.copy($scope.Devices[i]);
                        // delete device from database
                        devicesToChange.push(api.Device.RemoveDevice({ DeviceId: deleteDevice.DeviceId }).$promise);
                    }
                }

                if (devicesToChange.length === 0) {
                    $state.go('devices.view', {}, { reload: 'devices' });
                    return;
                }

                $rootScope.surpressErrors = true;
                let alreadyFinished = 0;
                const errors = [];
                devicesToChange.forEach((promise) => {
                    promise
                    .catch((err) => {
                        const foundDevices = $scope.Devices.filter((device) => err.resource.DeviceId === device.DeviceId);
                        if (foundDevices.length === 1) {
                            err.DeviceName = foundDevices[0].Name;
                        }
                        else if (foundDevices.length > 1) {
                            const names = [];
                            foundDevices.forEach((device) => {
                                names.push(device.Name);
                            });
                            err.DeviceName = names.join(',');
                        }
                        errors.push(err);
                    })
                    .finally(() => {
                        alreadyFinished++;
                        if (alreadyFinished === devicesToChange.length) {
                            if (errors.length === 0) {
                                $rootScope.surpressErrors = false;
                                $scope.$emit('loading-stop');
                                $state.go('devices.view', {}, { reload: 'devices' });
                                return;
                            }
            
                            displayErrorMessageForChangedDevicesPromise(errors);
                            $rootScope.surpressErrors = false;
                        }
                    });
                });

                
            }
        });

        function displayErrorMessageForChangedDevicesPromise(values) {
            var allDeleted = true;
            for (var i = 0; i < values.length; ++i) {
                if (values[i].Code === 'EX_LO_DEVICE_007') {
                        // ok, do nothing
                }
                else {
                    allDeleted = false;
                    break;
                }
            }

            var errorText;

            if (allDeleted) {
                /* possibly multiple devices tried to be deleted but they are
                in scenes, so display what devices cannot be deleted */
                var namesString = `"${values[0].DeviceName}"`;

                if (values.length === 1) {
                    errorText = $translate.instant('DEVICES_DeleteFailed_OneDevice')
                                 + ' '
                                 + namesString
                                 + ' '
                                 + $translate.instant('DEVICES_DeleteFailed_Is')
                                 + ' '
                                 + $translate.instant('DEVICES_DeleteFailed_SecondTextPart');
                } else {
                    for (var i = 1; i < values.length; ++i) {
                        namesString += ', "' + values[i].DeviceName + '"';
                    }
                    errorText = $translate.instant('DEVICES_DeleteFailed_MoreDevices')
                                 + ' '
                                 + namesString
                                 + ' '
                                 + $translate.instant('DEVICES_DeleteFailed_Are')
                                 + ' '
                                 + $translate.instant('DEVICES_DeleteFailed_SecondTextPart');
                }
            } else {
                errorText = $translate.instant('DEVICES_DeleteFailed_Text');
            }

            var infoParams = {
                "Type": 0,
                "Title": "DEVICES_DeleteFailed",
                "DisplayTextTranslated": errorText
            };
            $scope.$emit('loading-stop');
            infoModal(infoParams).then(function (modal) {
                modal.close.then(function () {
                    $scope.$emit('loading-start');
                    $state.go('devices.view', {}, { reload: 'devices' });
                });
            });
        }

        $scope.isTopDevice = function (device) {
            return (!device.ParentDeviceId || device.ParentDeviceId == '00000000-0000-0000-0000-000000000000');
        };

        $scope.itemsToDelete = function (device) {
            return !(device.$UI && device.$UI.delete);
        };
    }
]).//  end of DevicesEditCtrl


controller("DevicesCtrl", ["$filter", "$scope", "$state", "$stateParams", "$window", "DeviceFilter", 'FilteredDevices', "DevicesWithCustomFilter", "ENUM", "IsFilterActivated", "__DatapointValue", "__MenuEntry", "addFavoriteModal", "conf_guidEmpty", "deviceRoomPickerModal", "deviceScannerModal", "f_Interval", "viewMenuBarService", "xCenterConfig", "$q", "xcenterUtils",
    function ($filter, $scope, $state, $stateParams, $window, DeviceFilter, FilteredDevices, DevicesWithCustomFilter, ENUM, IsFilterActivated, __DatapointValue, __MenuEntry, addFavoriteModal, conf_guidEmpty, deviceRoomPickerModal, deviceScannerModal, f_Interval, viewMenuBarService, xCenterConfig, $q, xcenterUtils) {

        // scroll to top if enter from other state
        if($state.previous.parent !== 'devices') {
            $window.scrollTo(0, 0);
        }

        // define variables
        var intervalId = undefined;
        $scope.Devices = FilteredDevices;
        $scope.TopDevices = FilteredDevices;
        $scope.AllDevices = angular.copy($scope.Devices);
        $scope.DeviceTypes = ENUM.getDeviceTypesByFilter(1);
        $scope.DeviceTypesAsKeys = ENUM.getDeviceTypesByFilter('1AsKey');
        $scope.DevicesWithCustomFilter = DevicesWithCustomFilter !== 'true';
        $scope.DeviceFilter = DeviceFilter;
        $scope.activeFilter = IsFilterActivated;
        $scope.getClasses = xcenterUtils.getClasses;

        // set favorite button in head bar
        var o = {
            favoriteType: 'MenuEntry',
                favoriteObject: __MenuEntry.$buildRaw(
                    {
            "MenuEntryId": 'abc0000d-8838-4d81-afd8-52d6cac5c5d0',
            "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
            "DeviceId": '00000000-0000-0000-0000-000000000000',
            'CustomActionName': "DeviceManagement",
            'DisplayName': 'Geräte',
            'ImageName': 'geraete',
            'CustomActionDatas': {},
            $UI: {}
            })
        };
        if($stateParams.favorite != null)
        {
            o.favoriteObject =  $stateParams.favorite;
            o.favoriteType= 'Favorite';
        }
        viewMenuBarService.setFavorite(o);
        // set various buttons in head bar
        viewMenuBarService.setButtons({
            'startLearnButton': function () {
                if ($scope.intervalId) {
                    f_Interval.unregisterIntervalByAppId($scope.intervalId);
                }
                $scope.ModalActive = true;
                deviceScannerModal(function (data) {
                    // user pressed save data = true. Otherwise nothing to do
                    $scope.ModalActive = false;
                    if (data === true) {
                        $state.go('devices.view', {}, { reload: 'devices' });

                    }
                    $scope.setRefreshInterval();

                });
            },
            'editButton': function () {

                if ($scope.intervalId) {
                    f_Interval.unregisterIntervalByAppId($scope.intervalId);
                }


                $state.go('devices.edit');
            }
        });

        $scope.getDeviceType = function (DeviceType) {
            var l = $filter('filter')($scope.DeviceTypes, {'$pk': DeviceType});
            return l.length > 0 ? l[0] : {};
        };

        $scope.isTopDevice = function (device) {
            return (!device.ParentDeviceId || device.ParentDeviceId == '00000000-0000-0000-0000-000000000000');
        };

        $scope.isNewDeviceType = function (a, b) {
            if (b == undefined) return true;
            if (a == undefined) return true;
            return !(a == b);
        };

        $scope.setRefreshInterval = function () {
            // delete interval if it exists
            if ($scope.intervalId) {
                f_Interval.unregisterIntervalByAppId('interval.deviceControl.vizDataoints');
            }
            // create new interval
            if (xCenterConfig.interval.datapointValues > 0) {
                var i = {
                    'AppId': 'interval.deviceControl.vizDataoints',
                    delay: xCenterConfig.interval.devicecontrolVizualisationDatapointValues,
                    fn: function () {
                        if (!$scope.TopDevices || $scope.TopDevices.length === 0) {
                            return;
                        }

                        var dps ={};
                        var dp = [];
                        var promise = $q.defer();

                        for (var i = 0; i < $scope.TopDevices.length; i++) {
                            //  console.log('mv'+this.$UI.hasActiveManualValue);
                            if (!$scope.TopDevices[i].VisualizationDatapoints) {
                                continue;
                            }
                            for (var j = 0; j < $scope.TopDevices[i].VisualizationDatapoints.length; j++) {
                                let p = $scope.TopDevices[i].VisualizationDatapoints[j];
                                let v = $scope.TopDevices[i].VisualizationDatapoints[j].DatapointValue;
                                dps['k' + v.DatapointConfigId + '-d-' + v.DeviceId] = p;
                                dp.push(__DatapointValue.$buildRaw(v));
                            }
                        }
                        dp = __DatapointValue.$collection(dp).$refresh().$then(function () {
                            for (let i = 0; i < dp.length; i++) {
                                if(dps['k' + dp[i].DatapointConfigId + '-d-' + dp[i].DeviceId].DatapointValue.Value !== dp[i].Value)
                                {
                                    dps['k' + dp[i].DatapointConfigId + '-d-' + dp[i].DeviceId].DatapointValue.Value = dp[i].Value;
                                    dps['k' + dp[i].DatapointConfigId + '-d-' + dp[i].DeviceId].setValue(dp[i].Value);
                                    //dps['k' + dp[i].DatapointConfigId + '-d-' + dp[i].DeviceId].setReadValue();
                                }
                                if(dps['k' + dp[i].DatapointConfigId + '-d-' + dp[i].DeviceId].DatapointValue.Flags !== dp[i].Flags) {
                                    dps['k' + dp[i].DatapointConfigId + '-d-' + dp[i].DeviceId].DatapointValue.Flags = dp[i].Flags;
                                    dps['k' + dp[i].DatapointConfigId + '-d-' + dp[i].DeviceId].setReadFlags();
                                }
                            }

                            // Let's kick timeout for next interval
                            promise.resolve();


                        });
                        return promise.promise;
                    }
                };
                $scope.intervalId = f_Interval.registerInterval(i);
            }
        };

        $scope.changeFilter = function () {
            var selectedDeviceType = angular.copy($scope.DeviceFilter.DeviceTypes);
            var filterOptions = {
                DeviceType: {
                    selectable: 'multiple',
                    hideNav: false,
                    hideButtonSystemDevice: false,
                    selected: selectedDeviceType
                },
                MenuEntry: {
                    emptyRooms: true,
                    emptyRoomsButton: true,
                    selectable: 'multiple',
                    withChildIds: false,
                    selected: $scope.DeviceFilter.MenuEntries
                },
                Device: {
                    selectable: false,
                   // list: $scope.AllDevices
                },
                saveOnSelect: true,
                inline: false,
                title: 'Geräteliste filtern'
            };
            $scope.ModalActive = true;
            deviceRoomPickerModal(filterOptions).then(function (modal) {
                modal['close'].then(function (data) {
                    $scope.ModalActive = false;
                    if (data) {
                        var menuEntryFilter = false;
                        if (data['MenuEntry'] && data['MenuEntry'].length > 0) {
                            menuEntryFilter = data['MenuEntry'].map(x => x.MenuEntryId);
                        }

                        var deviceFilter = false;
                        if (data['DeviceType'] && data['DeviceType'].length > 0) {
                            deviceFilter = data['DeviceType'];
                        }

                        $state.go('devices.view', {
                            'deviceTypeFilter': deviceFilter.toString(),
                            'menuEntryFilter': menuEntryFilter.toString()
                        });
                    }
                });
            });
        };

        $scope.setMode = function (mode) {
            $scope.searchStyle = mode;
        };

        $scope.addFilterFavorite = function () {
            if (!$scope.favoriteFilter) {
                // Serialize Filters
                if(!$scope.DeviceFilter.DeviceTypes){ $scope.DeviceFilter.DeviceTypes = [];}
                if(!$scope.DeviceFilter.MenuEntries){ $scope.DeviceFilter.MenuEntries = [];}
                var o = {};
                o.$type = "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared";

                o.DisplayName = 'Filter';
                o.MenuEntryType = 3;
                o.CustomActionName = 'DevicesManagementWithFilter';
                o.CustomActionDatas = {};
                o.DeviceId = conf_guidEmpty;
                o.UserLevelRead = 0;
                o.UserLevelWrite = 0;
                o.UITags = [];
                o.UITags.push('DeviceTypeFilter:' + $scope.DeviceFilter.DeviceTypes.join('|'));
                o.UITags.push('MenuEntryFilter:' + $scope.DeviceFilter.MenuEntries.join('|'));
                o.ImageName = 'filter';
                $scope.favoriteFilter = o;
                $scope.favoriteFilter.$UI = {};
                var b = addFavoriteModal(o).then(function (modal) {
                    modal.close.then(function (data) {
                        if (data) {
                            $scope.favoriteFilter.$UI.Favorite = data;
                        }
                    })
                });
            } else {
                $scope.favoriteFilter = undefined;
                // TODO: delete favorite from register and main page?
            }
        };

        $scope.setAllDeviceTypes = function (bool) {
            angular.forEach($scope.Devices, function (value) {
                $scope.deviceTypeFilter[value.DeviceType] = bool;

            });
        };

        // recursive function to set roomFilter --> child rooms will get value of parent
        $scope.setRoomFilter = function (roomId, setBool, rightRoom, rooms) {
            // breakup clause
            if (!rooms) {
                return;
            }

            // iterate through all rooms, if right room is found, child room will get chosen value (setBool)
            for (var i = 0; i < rooms.length; ++i) {
                if (rightRoom || rooms[i].Entry.MenuEntryId == roomId) {
                    $scope.roomFilter[rooms[i].Entry.MenuEntryId] = setBool;
                    $scope.setRoomFilter(roomId, setBool, true, rooms[i].Children);
                } else {
                    $scope.setRoomFilter(roomId, setBool, rightRoom, rooms[i].Children);
                }
            }
        };

        // init new refresh interval
        $scope.setRefreshInterval();

        // refresh ENUMs after their update
        $scope.$on("$enumsUpdated", function () {
            $scope.DeviceTypes = ENUM.getDeviceTypesByFilter(1);
            $scope.DeviceTypesAsKeys = ENUM.getDeviceTypesByFilter('1AsKey');
        });

        $scope.$on("$destroy", function () {
            if ($scope.intervalId) {
                f_Interval.unregisterIntervalByAppId($scope.intervalId);
            }
        });
    }
]).filter('parentDevices', function () {
    return function (items, deviceId) {
        if (!deviceId) {
            return items;
        }
        if (!items) {
            return
        }

        return items.filter(function (element, index, array) {
            return (element.ParentDeviceId === deviceId && element.ParentDeviceId != '00000000-0000-0000-0000-000000000000');
        });

    };
});
